import { Card, CardInfo, Tag } from '@cowsquare/design';
import { Link } from 'gatsby';
import * as R from 'ramda';
import React from 'react';

const MedicalCard = ({ linkUrl, coverUrl, cardInfoData, title, tags, ...props }) => {
  return (
    <Card
      as={Link}
      to={linkUrl}
      variant="vertical"
      coverUrl={coverUrl}
      footer={cardInfoData && <CardInfo data={cardInfoData} />}
      {...props}
    >
      <Card.Meta title={title}>{!R.isEmpty(tags) && <Tag.Group maxCounts={2}>{tags}</Tag.Group>}</Card.Meta>
    </Card>
  );
};

export default MedicalCard;
